import Order from 'common/models/Order'

class OrdersController {
    /*@ngInject*/
    constructor($state, $stateParams, inventory, iconCache, $mdDialog, orderStore, utils, $scope) {
        "ngInject";
		_.extend(this, {
			name: 'orders',
			$state: $state,
			$stateParams: $stateParams,
			$mdDialog: $mdDialog,
			inventory: inventory,
			getIconFor: iconCache,
			orderStore: orderStore,
			utils: utils,
            $scope: $scope
		});

		this.ordersLoader = this.orderStore.getAllOrdersOfUser()
            .then(
                (orders) => {
                    this.orders = _.sortByOrder(_.map(orders, (order) => {
                        let flatOrderItems = this.utils.flattenOrderItems(order.order_items, order.item_stats, order.vehicle_statistics, order.property_type);
                        return _.extend(order, {itemColumns: this.getItemColumnsFromInventory(flatOrderItems, order.item_stats), formattedMoveDate: moment(order.order_time*1000), orderNo: this.utils.getOrderNo(order.id)});
                    }), 'order_time', 'desc');
                    this.timeSlotIndex = _.indexBy(this.timeSlots, 'value');
                    this.activeOrderIndex = this.checkForActiveOrder(this.orders);
                }
            );

        $scope.$watch(
            () => this.activeOrderIndex,
            (activeOrderIndex) => {
                if (!_.isUndefined(activeOrderIndex)) {
                    this.activeOrder = this.orders[activeOrderIndex];
                }
            }
        )
    }

    timeSlots = [
        {displayName: '8am - 10am', value: 'time_slot_1'},
        {displayName: '10am - 12pm', value: 'time_slot_2'},
        {displayName: '2pm - 4pm', value: 'time_slot_3'},
        {displayName: '4pm - 6pm', value: 'time_slot_4'}
    ]

    checkForActiveOrder(orders) {
        let activeOrderId = this.$stateParams.orderId;
        let activeOrderIndex = 0;
        if(activeOrderId) {
              activeOrderIndex = _.findIndex(orders, (order) => {
                 return order.id.toString() === activeOrderId;
             });
        }
        return activeOrderIndex;
    }

    getItemColumnsFromInventory (inventory, itemStatistics) {
        const packableItems = _.indexBy(itemStatistics, 'id');
        let itemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .map(item => _.extend(item, {
                isPackable: (packableItems[item.item_statistic_id] || {}).candidate_for_packing,
                requiresPacking: (packableItems[item.item_statistic_id] || {}).candidate_for_economy

            }))
            .groupBy(item => item.qualifiedName)
            // Update item valuation factoring in damage cover factor
            .map((items, category) => {
                const itemToCloneAsCategory = items[0];
                return _.extend({}, itemToCloneAsCategory, {
                    isPackable: (packableItems[itemToCloneAsCategory.item_statistic_id] || {}).candidate_for_packing,
                    requiresPacking: (packableItems[itemToCloneAsCategory.item_statistic_id] || {}).candidate_for_economy,
                    children: items,
                    quantity: items.length,
                    package_status: itemToCloneAsCategory.package_status
                })
            })
            .value();

        return _(itemsInInventory)
            .sortBy(item => item.score)
            .groupBy(item => this.utils.getRootNameOf(item, 2))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: children
            }, 2))
            .sortBy(item => item.score)
            .map(category => {
                category.counts = {};
                category.counts[category.qualifiedName] = {size: _.sum(category.children, 'quantity')};
                category.isPackable = !(_.every(category.children, { isPackable: false }));
                category.requiresPacking = _.every(category.children, { requiresPacking: true });
                // category.package_status = _.every(category.children, {package_status: true, isPackable: true});
                category.package_status = _.every(category.children, { package_status: true });
                category.disabled = _.every(category.children, (item) => _.isUndefined(item.isPackable) || !item.isPackable);
                return category;
            })
            .groupBy(item => this.utils.getRootNameOf(item, 1))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: children
            }, 1))
            .sortBy(category => this.utils.sortMajorCategories(category))
            .value();
    }

    goToBasic() {
        this.$state.go('base.basic', {orderId: 'new'});
    }

    goToMajorItems() {
        let order = this.orders[this.activeOrderIndex];
        this.$state.go('base.home', {orderId: order.id});
    }

    goToSpecifications() {
        let order = this.orders[this.activeOrderIndex];
        /**
         * If there are ZERO order items,
         *  go to others page
         * else go to specifications page
         */
        if (_.isEmpty(order.order_items)) {
            return this.$state.go('base.others', {orderId: order.id});
        }
        this.$state.go('base.specifications', {orderId: order.id});
    }

    goToQuotes() {
        let order = this.orders[this.activeOrderIndex];
        let quotePage = this.utils.getQuotePageForOrderWith(order.move_type, order.property_type);
        this.$state.go(quotePage, {orderId: order.id});
    }

    goToAddressPage() {
        let order = this.orders[this.activeOrderIndex];
        this.$state.go('base.location', {orderId: order.id});
    }

    goToPayment() {
        let order = this.orders[this.activeOrderIndex];
        this.$state.go('base.payment', {orderId: order.id});
    }

}


export default OrdersController;


// WEBPACK FOOTER //
// ./client/app/components/orders/orders.controller.js